<script setup lang="ts">
import {cn} from "@/lib/utils";
import BaseTooltip from "@/core/components/tooltips/BaseTooltip.vue";

defineProps<{
    // Rate from 0 to 100, null if not applicable.
    rate: number | null
    primary?: boolean;
}>();
</script>

<template>
  <div v-if="rate !== null" class="flex items-center gap-2">
    <span
      :class="cn('font-semibold w-9 text-right',{
        'text-primary': primary,
        'text-indigo-500': !primary
      })"
    >{{ rate }}%</span>
    <div class="w-20 h-2 bg-muted rounded-full overflow-hidden">
      <div
        :class="cn(
          'h-full rounded-full transition-all',
          {
            'bg-primary': primary,
            'bg-indigo-500': !primary
          })"
        :style="{ width: `${rate}%` }"
      />
    </div>
  </div>
  <div v-else class="w-9 text-right">
    <BaseTooltip>
      <template #content>
        Non mesurable pour un SMS
      </template>
      <span class="text-muted-foreground">—</span>
    </BaseTooltip>
  </div>
</template>

<style scoped>

</style>
